import React, { useEffect, useMemo, useState } from 'react'
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from '../../components'
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from '../../components/NextUITable'
import { usePost } from '../../api/reactQueryCustomHooks'
import { apiRoute, ENUM_PAGEACTION_TYPE, GetLoginCredentialDb, linksUrl, URIEncrypt } from '../../constants/enum'
import { faEdit, faPlus, faReceipt, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Modal, ModalBody, ModalHeader, ModalContent, useDisclosure } from '@heroui/react'
import { useDispatch, useSelector } from 'react-redux'
import { resetDetailParams, resetRecVouDetail, setDetailParams, setNewEntryMode, setVouReportDetail } from '../../state/receiveEntrySlice'
import ConfirmBox from '../../components/ConfirmBox'
import { toast } from 'react-toastify'
import { calculateTotal } from '../../Utility/utility'
import { resetPayDetailParams, resetPayVouDetail, setPayDetailParams, setPayNewEntryMode, setPayVouReportDetail } from '../../state/paymentEntrySlice'
import { enum_Report_Type } from '../report/ReportUtility'
import ReportViewer from '../report/ReportViewer'

const TransactionEntryMaster = () => {
    const {
        isOpen: isOpenModel,
        onOpen: onOpenModel,
        onOpenChange: onOpenModelChange
    } = useDisclosure()

    const { token, user } = useSelector((state) => state.auth)
    const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { etype } = useParams()
    const [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")
    const [selVouType, setSelVouType] = useState("")
    const [entryLabel, setEntryLabel] = useState("")
    const INITIAL_VISIBLE_COLUMNS = ["actions", "BookName", "PartyName", "Vou_No", "Remark", "Chq_Amt", "Chq_Date"]
    // const [data, setData] = useState([])
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard)
        dispatch(resetDetailParams())
        dispatch(resetPayDetailParams())
    }, [])

    useEffect(() => {
        const params = [URIEncrypt.Payment, URIEncrypt.Receive]
        if (!params.includes(String(etype)))
            navigate(linksUrl.dashboard)

        if (etype && etype != "") {

            let t_vouType = ""
            if (etype == URIEncrypt.Receive) {
                t_vouType = 'R'
                setEntryLabel("Receive")
            }
            if (etype == URIEncrypt.Payment) {
                t_vouType = 'G'
                setEntryLabel("Payment")
            }
            setSelVouType(t_vouType)
            funLoadData(t_vouType)
        }
    }, [etype])
    const { isPending, isError,
        //  data: EntryData = [],
        data = [],
        mutate: filterData } = usePost({
            url: apiRoute.transactionEntry.fetch,
            queryKey: "Receive Entry Data"
        })
    const exportColumns = [
        {
            name: "Book Name",
            uid: "BookName",
        },
        {
            name: "PartyName",
            uid: "Party Name",
        },
        {
            name: "Vou No",
            uid: "Vou_No",
        },
        {
            name: "Narration",
            uid: "Remark",
        },
        {
            name: "Amount",
            uid: "Chq_Amt",
        },
        {
            name: "Trans.Date",
            uid: "Chq_Date",
            type: COLUMN_TYPE.date
        },




    ]
    const totalRecAmt = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Chq_Amt",
            }),
        [data])


    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center
        },
        {
            name: "Book Name",
            uid: "BookName",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Party Name",
            uid: "PartyName",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },


        {
            name: "Vou No",
            uid: "Vou_No",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Narration",
            uid: "Remark",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            isLineBreak: true
        },
        {
            name: "Amount",
            uid: "Chq_Amt",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalRecAmt,
            },
        },
        {
            name: "Trans.Date",
            uid: "Chq_Date",
            align: COLUMN_ALIGN_TYPE.center,
            type: COLUMN_TYPE.date,
            sortable: true
        },

    ]



    const funLoadData = (vouType) => {
        filterData({
            data: {
                comp_code: compCode.join(","),
                vou_type: vouType,
                trans_id: ""
            }
        })
    }

    const reportModel = () => {
        return (
            <Modal
                isOpen={isOpenModel}
                onOpenChange={onOpenModelChange}
                size="md">
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-row gap-1">
                                Voucher
                            </ModalHeader>
                            <ModalBody>
                                <div className="flex flex-col">
                                    <ReportViewer props_ReportType={selVouType == 'R' ? enum_Report_Type.RECVOUCHER
                                        : selVouType == 'G' ? enum_Report_Type.PAYVOUCHER : ""

                                    } />
                                </div>
                            </ModalBody>
                        </>

                    )}
                </ModalContent>
            </Modal>
        )
    }

    let downloadDataFooter = {
        BookName: "", PartyName: "", Vou_No: "", Remark: "", Chq_Amt: "Total:" + totalRecAmt,
        Chq_Date: " ",
    }
    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                let obj = {
                    compcode: row.CompCode,
                    transactionid: row.TransactionId,
                    pacid: row.Pac_Id,
                    voutype: row.Vou_Type,
                }
                setItemToEdit(obj)


            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.CompCode, vou_type: row.Vou_Type })
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#075985" icon={faReceipt} />,
            onClick: (row) => {
                //dispatch(resetr())

                dispatch(resetPayVouDetail())
                dispatch(resetRecVouDetail())
                if (selVouType == 'R')
                    dispatch(setVouReportDetail(row))
                else if (selVouType == 'G')
                    dispatch(setPayVouReportDetail(row))

                onOpenModel()
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },

    ]
    const onSuccessDelete = (data) => {
        setItemToDelete("")
        funLoadData(selVouType);
        toast.success("Entry Deleted",
            { position: "top-center" })

    }
    const { mutate: FnDeleteEntry } = usePost({
        url: apiRoute.transactionEntry.deleteEntry,
        queryKey: "DeleteReceiveEntry",
        onSuccessTasks: onSuccessDelete,

    })

    const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete != "" && itemToDelete != null && Object.keys(itemToDelete).length > 0) {
                FnDeleteEntry({
                    data: {
                        comp_code: itemToDelete.comp_code,
                        transaction_id: itemToDelete.transaction_id,
                        vou_type: itemToDelete.vou_type
                    }
                })
            }
            else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                if (selVouType == 'R') {
                    dispatch(setDetailParams(itemToEdit))
                    dispatch(setNewEntryMode(false))
                }
                else if (selVouType == 'G') {
                    dispatch(setPayDetailParams(itemToEdit))
                    dispatch(setPayNewEntryMode(false))
                }

                navigate(funGetNaviLink())
            }
        }
        else {
            setItemToDelete("")
            setItemToEdit("")
            setPageActionType("")
        }
    }
    const funGetNaviLink = () => {
        if (selVouType == 'R')
            return linksUrl.receiveEntry.receive + "/" + etype + linksUrl.receiveEntry.createReceiveEntry;
        else
            return linksUrl.paymentEntry.payment + "/" + etype + linksUrl.paymentEntry.createPaymentEntry;
    }
    const handleAddNew = () => {
        if (selVouType == 'G')
            dispatch(resetPayDetailParams())
        else if (selVouType == 'R')
            dispatch(resetDetailParams())
        navigate(funGetNaviLink())
    }
    if (isPending) {
        return <LoadingCard />
    }
    if (isError) {
        return <ErrorCard />
    }
    return (
        <div>
            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}
            <MainContainer pageName={`${entryLabel} Entries`} breadcrumbs={["Account", entryLabel + " Entry"]} >
                <div className="" style={{ textAlign: "right" }}>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                {reportModel()}
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    // handleDataChange={handleDataChange}
                    exportColumns={exportColumns}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    downloadDataFooter={downloadDataFooter}
                    showAdvanceFilter={false}
                    downloadFileName='ReceiveEntry-list'
                    id="TransactionId"
                >
                </NextUITable>
            </MainContainer>
        </div>
    )
}

export default TransactionEntryMaster